<template>
    <div>
        <div v-if="this.isClient && this.clientAccountGenerationSetting == '1' && this.clientAccountId == '' && !this.hasClientAccount"> 
            <div class="alert alert-info"> <strong>Le compte client va se générer automatiquement.</strong> Vous pouvez trouvez ci dessous le nom du compte qui sera générer automatiquement</div>
            <div class="ix-table-box">
                <table class="ix-table">
                    <thead>
                        <tr>
                            <th class=" text-center">Compte général</th>
                            <th class=" text-center">Compte auxiliaire</th>
                            <th class=" text-center">Désignation</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-center">
                                <input type="text" class="form-control" v-model="clientAccount.general" name="client-general" id="client-general">
                            </td>
                            <td class="text-center">
                                <input type="text" class="form-control" v-model="clientAccount.auxiliary" name="client-auxiliary" id="client-auxiliary">
                            </td>
                            <td class="text-center">
                                <input type="text" class="form-control" v-model="clientAccount.designation" name="client-designation" id="client-designation">
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <br>
            <div class="alert alert-warning" v-if="this.existingAuxilary"> 
                <strong>Le compte existe déjà sous ce nom. Il va donc être créé en doublon </strong>.
                <br> 
                Pour éviter de générer un compte en double, vous pouvez créer  manuellement le compte ou désactiver le paramètre qui autorise les doublons
            </div>
            <br>
        </div>

        <div v-if="this.isSupplier && this.supplierAccountGenerationSetting == '1' && this.supplierAccountId == '' && !this.hasSupplierAccount">
        <div class="alert alert-info"> <strong>Le compte fournisseur va se générer automatiquement.</strong> Vous pouvez trouvez ci dessous le nom du compte qui sera générer automatiquement</div>
        <div class="ix-table-box">
            <table class="ix-table">
                <thead>
                    <tr>
                        <th class=" text-center">Compte général</th>
                        <th class=" text-center">Compte auxiliaire</th>
                        <th class=" text-center">Désignation</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-center">
                            <input type="text" class="form-control" v-model="supplierAccount.general" name="supplier-general">
                        </td>
                        <td class="text-center">
                            <input type="text" class="form-control" v-model="supplierAccount.auxiliary" name="supplier-auxiliary">
                        </td>
                        <td class="text-center">
                            <input type="text" class="form-control" v-model="supplierAccount.designation" name="supplier-designation">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <br>
        <div class="alert alert-warning" v-if="this.existingAuxilary"> 
            <strong>Un compte auxiliaire existe déjà sous ce nom. Il va donc être créé en doublon </strong>.
            <br> 
            Pour éviter de générer un compte auxiliaire en double, vous pouvez modifier manuellement le compte ou désactiver le paramètre qui autorise les doublons
        </div>
        <br>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AccountingAccountGeneration',
    props: {
        isEntrepriseInputId: String,
        legalFormInputId: String,
        nameInputId: String, 
        firstNameInputId: { type: String, default: '' }, 
        stateInputId: String,
        isSupplierInputId: String,
        auxiliariesUrl: '', 
        getCompanyUrl: '',
        duplicateAccountSetting: String,
        clientAccountGenerationSetting: String,
        supplierAccountGenerationSetting: String,
        clientAccountId: {type : String, default: ''},
        supplierAccountId: {type : String, default: ''},
    }, 
    
    data() {
        return {
            existingAuxiliaries: [],
            clientAccount: {
                general: '411',
                auxiliary: '',
                designation: 'Client'
            },
            supplierAccount: {
                general: '401',
                auxiliary: '',
                designation: 'Fournisseur'
            },
            
            isEntrepriseInputIdRef : null,
            legalFormInputIdRef : null,
            nameInputIdRef : null,
            firstNameInputIdRef : null,
            stateInputIdRef : null,
            isSupplierInputIdRef : null,
            existingAuxilary : false,
            hasSupplierAccount : null,
            hasClientAccount : null,
            
            isSupplier : false,
            isClient : false,
        }

    },
    methods: {
        loadExistingAuxiliaries() {
            $.ajax({
                url: this.auxiliariesUrl,
                type: 'GET',
                success : (response) => {
                    this.existingAuxiliaries = response;
                    this.updateAuxiliaries();
                },
                error: function(xhr, status, error) {
                    console.error(error);
                }
            });
        },

        updateAuxiliaries() {
            let legalForm = this.legalFormInputIdRef.tagName == "SELECT" ? this.legalFormInputIdRef.options[this.legalFormInputIdRef.selectedIndex].text : this.legalFormInputIdRef.value;

            let isEnterprise = this.isEntrepriseInputIdRef.value ? this.isEntrepriseInputIdRef.value : '';
            let name = this.nameInputIdRef.value ? this.nameInputIdRef.value : '';
            let firstname = this.firstNameInputIdRef ? this.firstNameInputIdRef.value : ''; 
            // Cas ou le prénom n'est pas renseigné (lors de l'édit on a le nom de l'entreprise qui est composé du nom et du prénom)
            if (firstname == '' && (this.nameInputId == "autocomplete_company_name") && isEnterprise == "0") {
                //On vérifie si le nom est composé du nom et du prénom
                if(name.includes(' ')) {
                    let nameParts = name.split(' ');
                    name = nameParts[0];
                    firstname = nameParts[1];
                }
            }


            let auxiliary = '';
            let legalFormClean = '';
            let nameClean = '';
            let firstnameClean = '';


            legalFormClean = legalForm.normalize('NFD').replace(/[^0-9a-z]/gi, '');
            nameClean = name.normalize('NFD').replace(/[^0-9a-z]/gi, '');
            firstnameClean = firstname.normalize('NFD').replace(/[^0-9a-z]/gi, '');

            if (isEnterprise == "1") {
                auxiliary = (legalFormClean.substring(0, 2) + nameClean.substring(0, 3)).toUpperCase();
            } else {
                auxiliary = (nameClean.substring(0, 3) + firstnameClean.substring(0, 2)).toUpperCase();
            }
            auxiliary = auxiliary.padEnd(5, '0');
            let i = 0;
            let originalAuxiliary = auxiliary;
            
            //On vérifie si le compte auxiliaire est en double
            if (this.duplicateAccountSetting == "0" ) {
                while (this.existingAuxiliaries.includes(auxiliary)) {
                    const numberLength = i.toString().length;
                    const fixedPartLength = Math.max(0, originalAuxiliary.length - numberLength);
                    auxiliary = originalAuxiliary.substring(0, fixedPartLength) + i;
                    i++;
                }
            }
            this.clientAccount.auxiliary = auxiliary;
            this.supplierAccount.auxiliary = auxiliary;

            this.clientAccount.designation = "Client - " + this.nameInputIdRef.value;
            this.supplierAccount.designation = "Fournisseur - " + this.nameInputIdRef.value;
        },

        updateState() {
            let state = this.stateInputIdRef.value;
            if( state == "3")
                this.isClient = true;
            else 
                this.isClient = false;
        },

        updateIsSupplier() {
            let isSupplier = this.isSupplierInputIdRef.value;
            if( isSupplier == "1")
                this.isSupplier = true;
            else 
                this.isSupplier = false;
        },


        checkAuxiliaryExists(auxiliary) {
            if (this.existingAuxiliaries.includes(auxiliary)) {
                this.existingAuxilary = true;
            } else {
                this.existingAuxilary = false;
            }
        },

        getCompany(id){
            //On reforme l'url pour obtenir les informations de l'entreprise
            $.ajax({
                url: this.getCompanyUrl + '/' + id,
                type: 'GET',
                success : (response) => {
                    if(response.company.provider_accounting_account_id != null){
                        this.hasSupplierAccount = true;
                    } else {
                        this.hasSupplierAccount = false;
                    }

                    if( response.company.client_accounting_account_id != null){
                        this.hasClientAccount = true;
                    } else {
                        this.hasClientAccount = false;
                    }
                    //On change la valeur des champs cachés
                    this.isEntrepriseInputIdRef.value = response.company.is_enterprise  ? response.company.is_enterprise : '';
                    this.legalFormInputIdRef.value = response.company.legal_form_text ? response.company.legal_form_text : '';
                    this.nameInputIdRef.value = response.company.name ? response.company.name : '';
                    this.stateInputIdRef.value = response.company.state ? response.company.state : '';
                    this.updateAuxiliaries();
                },
                error: function(xhr, status, error) {
                    console.error(error);
                }
            });
        }

    },  

    watch: {
        'supplierAccount.auxiliary': function (newValue) {
            this.checkAuxiliaryExists(newValue);
        },

        'clientAccount.auxiliary': function (newValue) {
            this.checkAuxiliaryExists(newValue);
        },
       
    },
    mounted() {
        this.loadExistingAuxiliaries();

        this.isEntrepriseInputIdRef = document.getElementById(this.isEntrepriseInputId);
        this.legalFormInputIdRef = document.getElementById(this.legalFormInputId);
        this.nameInputIdRef = document.getElementById(this.nameInputId);
        this.firstNameInputIdRef = document.getElementById(this.firstNameInputId);
        this.stateInputIdRef = document.getElementById(this.stateInputId);
        this.isSupplierInputIdRef = document.getElementById(this.isSupplierInputId);


        if (this.isEntrepriseInputIdRef) {
            this.isEntrepriseInputIdRef.addEventListener('input', this.updateAuxiliaries);
        }
        if (this.legalFormInputIdRef) {
            this.legalFormInputIdRef.addEventListener('input', this.updateAuxiliaries);
        }
        if (this.nameInputIdRef) {
            this.nameInputIdRef.addEventListener('input', this.updateAuxiliaries);
        }
        if (this.firstNameInputIdRef) {
            this.firstNameInputIdRef.addEventListener('input', this.updateAuxiliaries);
        }
        
        if (this.stateInputIdRef) {
            this.stateInputIdRef.addEventListener('input', this.updateState);
            // On lance la fonction pour initialiser la valeur de isClient
            this.updateState();
        }
        if (this.isSupplierInputIdRef) {
            this.isSupplierInputIdRef.addEventListener('input', this.updateIsSupplier);
            // On lance la fonction pour initialiser la valeur de isSupplier
            this.updateIsSupplier();
        }

        let companyNameIdRef = document.getElementById('company_name');
        if (companyNameIdRef) {
            // Il s'agit de l'id de l'autocomplete dans la page de création d'une commande fournisseur
            // Par défaut, on ne veut pas afficher le composant de génération de compte fournisseur 
            //car il n'y a pas d'entreprise sélectionnée
            this.hasSupplierAccount = true;
            this.hasClientAccount = true;
        }

        $('#company_name').on('input',( ) => {
            if( $('#company_name').val() == ''){
                this.hasSupplierAccount = true;
                this.hasClientAccount = true;
            }
            else {
                this.hasSupplierAccount = false;
                this.hasClientAccount = false;
            }
            this.updateAuxiliaries();
            
        });
        
        $('#company_name').on('autocompletechange change', () => {
            var companyId = $('#company_id').val();
            console.log(companyId);
            if (companyId) {
                this.getCompany(companyId);
            }
        });

        $('#address_label').on('autocompletechange change', () => {
            var companyId = $('#company_id').val();
            if (companyId) {
                this.getCompany(companyId);
            } 
        });

        $('.input-trade-company-setup').change(() =>{
            var companyId = $('#company_id').val();
            if (companyId) {
                this.getCompany(companyId);
            } 
        });

        if($('#company_id').val()){
            this.getCompany($('#company_id').val());
        }


    }
        
}

</script>
